module.exports = __webpack_public_path__ + "static/media/[Annual_Oration]2012.ffb27d39.md";